import PriceFormulaApi from "@/api/baby-piglet/priceFormulaApi";

export default {
  namespaced: true,
  states: {},
  mutations: {},
  actions: {
    async addOrUpdate({dispatch}, {form}) {
      try {
        const response = await PriceFormulaApi.addOrUpdate(form);
        dispatch('NOTIFY_MSG', 'babyPiglet.notifications.savePriceFormula', {root: true})
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async calculate({dispatch}, { pigletPrice, salaryOld }) {
      try {
        const response = await PriceFormulaApi.calclulate(pigletPrice, salaryOld);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetch({dispatch}) {
      try {
        const response = await PriceFormulaApi.fetch();
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    }
  }
}
